/**
 * The installed plugins' CONNECTION TYPES (PLUGINS.md) — ``{id: {id, label, displayName, wizard, room}}`` from
 * ``GET /tools/plugins`` — cached per page load (the catalog changes only with a deploy). The Connections UI reads
 * these instead of naming any vendor's connection itself.
 */
import { useEffect, useState } from 'react';
import { listPlugins } from '../services/toolsApi.js';

let _cache = null;
let _inflight = null;

/** PURE — the connection types of the plugins THIS workspace installed, by id (PLUGINS.md §6). */
export function connectionTypesOf(plugins) {
  const out = {};
  for (const p of (plugins || [])) {
    if (p?.install && p.install.installed === false) continue;
    for (const t of (p.connectionTypes || [])) if (t?.id && !out[t.id]) out[t.id] = { ...t, pluginId: p.id };
  }
  return out;
}

export function loadPluginConnectionTypes() {
  if (_cache) return Promise.resolve(_cache);
  if (!_inflight) {
    _inflight = listPlugins().then((d) => { _cache = connectionTypesOf(d?.plugins || []); return _cache; })
      .catch(() => ({})).finally(() => { _inflight = null; });
  }
  return _inflight;
}

/** What is loaded so far (pure helpers that can't wait; {} until the first load). */
export function cachedPluginConnectionTypes() { return _cache || {}; }

export function resetPluginConnectionTypes() { _cache = null; _inflight = null; }

export default function usePluginConnectionTypes() {
  const [types, setTypes] = useState(_cache || {});
  useEffect(() => {
    let cancelled = false;
    loadPluginConnectionTypes().then((t) => { if (!cancelled) setTypes(t || {}); });
    return () => { cancelled = true; };
  }, []);
  return types;
}
